<div class="container">
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="card">
                <div class="card-header">
                    {{ 'navigation.supplier-regions' | translate }}
                </div>
                <div class="card-body">
                    <form class="form-horizontal">
                        <div class="form-group row">
                            <div class="col-md-6 col-sm-12">
                                <label for="supplier-regions" class="control-label">
                                    {{ 'navigation.supplier-regions' | translate }}
                                </label>
                                <angular2-multiselect
                                    id="supplier-regions"
                                    name="supplierRegions"
                                    [(ngModel)]="regionsModel"
                                    [data]="supplierRegions"
                                    (onAddFilterNewItem)="onRegionCreated($event)"
                                    [settings]="regionsSettings"
                                    (onSelect)="onRegionSelect($event)"
                                >
                                </angular2-multiselect>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <label for="assignedZipCodes" class="control-label">
                                    {{ 'supplier-regions.zip-codes' | translate }}
                                </label>
                                <angular2-multiselect
                                    id="assignedZipCodes"
                                    name="assignedZipCodes"
                                    [data]="availableZipCodes"
                                    [settings]="zipCodesSettings"
                                    [(ngModel)]="zipCodesModel"
                                    (onSelect)="onZipCodesSelect($event)"
                                    (onDeSelect)="onZipCodeUnassignment($event)"
                                >
                                </angular2-multiselect>
                            </div>
                            <div class="col-12 mt-2">
                                <div class="card">
                                    <div class="card-header">
                                        {{
                                            'supplier-regions.assigned-zip-codes'
                                                | translate
                                        }}
                                    </div>
                                    <div class="card-body">
                                        <app-zip-badge
                                            *ngFor="
                                                let zipCode of supplierRegionsService.selectedZipCodes
                                                    | async
                                            "
                                            [zipCode]="zipCode"
                                            (onDelete)="onZipCodeUnassignment($event)"
                                        ></app-zip-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-2">
                                <div class="card">
                                    <div class="card-header">
                                        {{
                                            'supplier-regions.position-title' | translate
                                        }}
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12">
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    [(ngModel)]="_lat"
                                                    [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                                    id="lat"
                                                    placeholder="{{
                                                        'common.lat' | translate
                                                    }}"
                                                    (change)="onChangeLatLon()"
                                                />
                                            </div>

                                            <div class="col-md-6 col-sm-12">
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    [(ngModel)]="_long"
                                                    [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                                    id="long"
                                                    (change)="onChangeLatLon()"
                                                    placeholder="{{
                                                        'common.long' | translate
                                                    }}"
                                                />
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <a
                                                target="_blank"
                                                href="https://www.openstreetmap.org/#map=14/{{
                                                    _lat
                                                }}/{{ _long }}"
                                                >{{ 'common.goto-map' | translate }}</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-2">
                                <div class="card">
                                    <div class="card-header">
                                        {{
                                            'supplier-regions.utilizations-title'
                                                | translate
                                        }}
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12">
                                                <label
                                                    for="sameDayUtilization"
                                                    class="control-label"
                                                >
                                                    {{
                                                        'supplier-regions.same-day-utilization-title'
                                                            | translate
                                                    }}
                                                </label>
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    [(ngModel)]="_sameDayUtilization"
                                                    [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                                    id="sameDayUtilization"
                                                    placeholder="{{
                                                        'common.percent' | translate
                                                    }}"
                                                    (change)="onChangeUtilizations()"
                                                />
                                            </div>

                                            <div class="col-md-6 col-sm-12">
                                                <label
                                                    for="nextDaysUtilization"
                                                    class="control-label"
                                                >
                                                    {{
                                                        'supplier-regions.next-days-utilization-title'
                                                            | translate
                                                    }}
                                                </label>
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    [(ngModel)]="_nextDaysUtilization"
                                                    [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                                    id="nextDaysUtilization"
                                                    (change)="onChangeUtilizations()"
                                                    placeholder="{{
                                                        'common.percent' | translate
                                                    }}"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-2">
                              <div class="card">
                                <div class="card-header">
                                  {{
                                            'supplier-regions.delivery-parameters-title'
                                                | translate
                                  }}
                                </div>
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <label for="deliveryWindowEndToleranceSeconds"
                                             class="control-label">
                                        {{
                                                        'supplier-regions.delivery-window-end-tolerance-seconds'
                                                            | translate
                                        }}
                                      </label>
                                      <input type="number"
                                             class="form-control"
                                             [(ngModel)]="_deliveryWindowEndToleranceSeconds"
                                             [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                             id="deliveryWindowEndToleranceSeconds"
                                             (change)="onChangeDeliveryWindowEndToleranceSeconds()"
                                             min="0"
                                             step="1" />
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                      <label for="shiftPickingToDeliveryRatio"
                                             class="control-label">
                                        {{
                                                        'supplier-regions.shift-picking-to-delivery-ratio'
                                                            | translate
                                        }}
                                      </label>
                                      <input type="number"
                                             class="form-control"
                                             [(ngModel)]="_shiftPickingToDeliveryRatio"
                                             [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                             id="shiftPickingToDeliveryRatio"
                                             (change)="onChangeShiftPickingToDeliveryRatio()"
                                             min="0"
                                             max="1"
                                             step="0.01" />
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6 col-sm-12">
                                      <label for="travelTimeMultiplier"
                                             class="control-label">
                                        {{
                                                        'supplier-regions.travel-time-multiplier'
                                                            | translate
                                        }}
                                      </label>
                                      <input type="number"
                                             class="form-control"
                                             [(ngModel)]="_travelTimeMultiplier"
                                             [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                             id="travelTimeMultiplier"
                                             (change)="onChangeTravelTimeMultiplier()"
                                             min="0"
                                             max="100"
                                             step="0.01" />
                                    </div>

                                    <div class="col-md-6 col-sm-12">
                                      <label for="deliveryServiceTimeSeconds"
                                             class="control-label">
                                        {{
                                                        'supplier-regions.delivery-service-time-seconds'
                                                            | translate
                                        }}
                                      </label>
                                      <input type="number"
                                             class="form-control"
                                             [(ngModel)]="_deliveryServiceTimeSeconds"
                                             [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                             id="deliveryServiceTimeSeconds"
                                             (change)="onChangeDeliveryServiceTimeSeconds()"
                                             min="0"
                                             step="1" />
                                    </div>
                                  </div>
                                  <div class="row">


                                    <div class="col-md-6 col-sm-12">
                                      <label for="useDynamicRouting"
                                             class="control-label">
                                        {{
                                                        'supplier-regions.use-dynamic-routing'
                                                            | translate
                                        }}
                                      </label>
                                      <input type="checkbox"
                                             style="box-shadow: none;"
                                             class="form-control"
                                             [(ngModel)]="_useDynamicRouting"
                                             [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                             id="useDynamicRouting"
                                             (change)="onChangeUseDynamicRouting()" />
                                    </div>

                                    <div class="col-md-6 col-sm-12"></div>
                                  </div>
                                </div>
                              </div>
                              </div>

                              <div class="col-12 mt-2">
                                <div class="card">
                                  <div class="card-header">
                                    {{
                                    'supplier-regions.delivery-replan-title'
                                        | translate
                                    }}
                                  </div>
                                
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-md-4 col-sm-12">
                                        <label for="deliveryDate"
                                               class="control-label">
                                          {{
                                          'supplier-regions.routes-replan-date'
                                              | translate
                                          }}
                                        </label>
                                        <input
                                          type="date"
                                          class="form-control"
                                          id="deliveryDate"
                                          [(ngModel)]="deliveryDate"
                                          (ngModelChange)="unassignedTimeSlotPlan = null"
                                          [ngModelOptions]="{ standalone: true }"
                                      />
                                      </div>
                                      <div class="col-md-4 col-sm-12">
                                        <label for="routesReplan"
                                               class="control-label">
                                          {{
                                                        'supplier-regions.routes-replan'
                                                            | translate
                                          }}
                                        </label><br/>
                                        <lib-btn-progress (onClick)="onRoutesReplan()"
                                                          [btnClass]="'btn btn-primary'"
                                                          [iconClass]="'fa fa-car'"
                                                          [inProgress]="isRoutesReplanInProgress"
                                                          [disabled]="isSaveInProgress || isDeleteInProgress || isRoutesReplanInProgress || isUnassignedTimeSlotPlanningInProgress || !deliveryDate || !regionsModel?.length">
                                          {{ 'supplier-regions.routes-replan-button' | translate }}
                                        </lib-btn-progress>
                                      </div>
                                      <div class="col-md-4 col-sm-12">
                                        <label for="unassignedTimeSlotPlanning"
                                               class="control-label">
                                          {{ 'supplier-regions.unassigned-timeslot-planning' | translate }}
                                        </label><br/>
                                        <lib-btn-progress
                                          (onClick)="onPlanUnassignedTimeSlots()"
                                          [btnClass]="'btn btn-primary'"
                                          [iconClass]="'fa fa-magic'"
                                          [inProgress]="isUnassignedTimeSlotPlanningInProgress"
                                          [disabled]="isSaveInProgress || isDeleteInProgress || isRoutesReplanInProgress || isUnassignedTimeSlotPlanningInProgress || !deliveryDate || !regionsModel?.length">
                                          {{ 'supplier-regions.unassigned-timeslot-planning-button' | translate }}
                                        </lib-btn-progress>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6 col-sm-12">
                                        <label for="userCurrentTime"
                                               class="control-label">
                                          {{
                                          'supplier-regions.use-current-time'
                                              | translate
                                          }}
                                        </label>
                                        <input type="checkbox"
                                             style="box-shadow: none;"
                                             class="form-control"
                                             [(ngModel)]="useCurrentTime"
                                             [ngModelOptions]="{
                                                        standalone: true
                                                    }"
                                             id="useCurrentTime"/>
                                      </div>
                                      <div class="col-md-6 col-sm-12">
                                        
                                      </div>
                                    </div>
                                    <div *ngIf="unassignedTimeSlotPlan"
                                         class="mt-3">
                                      <div class="alert alert-info mb-2">
                                        <div class="mb-1">
                                          {{ getUnassignedTimeSlotPlanStatusKey() | translate }}
                                        </div>
                                        <span class="mr-3">
                                          {{ 'supplier-regions.unassigned-orders' | translate }}:
                                          {{ unassignedTimeSlotPlan.totalUnassignedOrders }}
                                        </span>
                                        <span class="mr-3">
                                          {{ 'supplier-regions.planned-orders' | translate }}:
                                          {{ unassignedTimeSlotPlan.plannedOrderCount }}
                                        </span>
                                        <span>
                                          {{ 'supplier-regions.still-unassigned-orders' | translate }}:
                                          {{ unassignedTimeSlotPlan.stillUnassignedOrderCount }}
                                        </span>
                                      </div>

                                      <div class="table-responsive">
                                        <table class="table table-sm table-striped mb-0">
                                          <thead>
                                            <tr>
                                              <th>{{ 'supplier-regions.order' | translate }}</th>
                                              <th>{{ 'supplier-regions.suggested-timeslot' | translate }}</th>
                                              <th>{{ 'supplier-regions.suggested-courier' | translate }}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr *ngFor="let order of unassignedTimeSlotPlan.orders">
                                              <td>#{{ order.orderCode }}</td>
                                              <ng-container *ngIf="order.planned; else notPlanned">
                                                <td>
                                                  {{ order.suggestedTimeSlotStart | date:'HH:mm' }}–{{ order.suggestedTimeSlotEnd | date:'HH:mm' }}
                                                </td>
                                                <td>{{ order.suggestedCourierName }}</td>
                                              </ng-container>
                                              <ng-template #notPlanned>
                                                <td colspan="2">
                                                  {{ 'supplier-regions.not-planned' | translate }}
                                                </td>
                                              </ng-template>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>           
                    </form>
                </div>
                <div class="card-footer">
                    <div class="btn-toolbar justify-content-between">
                        <div class="btn-group btn-group-sm">
                            <lib-btn-progress
                                (onClick)="onRegionsSave()"
                                [btnClass]="'btn btn-success'"
                                [iconClass]="'fa fa-check'"
                                [inProgress]="isSaveInProgress"
                                [disabled]="isDeleteInProgress"
                            >
                                {{ 'supplier-regions.save-regions' | translate }}
                            </lib-btn-progress>
                            <lib-btn-progress
                                (onClick)="
                                    modalService.setModalVisibility(
                                        true,
                                        'delete-region-confirmation'
                                    )
                                "
                                [btnClass]="'btn btn-warning'"
                                [iconClass]="'fa fa-trash'"
                                [disabled]="!isSelectedRegionSaved || isSaveInProgress"
                                [inProgress]="isDeleteInProgress"
                            >
                                {{
                                    'supplier-regions.delete-selected-region' | translate
                                }}
                            </lib-btn-progress>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<lib-modal
    componentID="delete-region-confirmation"
    [title]="'supplier-regions.confirm-delete' | translate"
>
    <p>{{ 'supplier-regions.region-delete-confirmation' | translate }}</p>
    <div class="btn-toolbar justify-content-between">
        <div class="btn-group btn-group-sm">
            <button (click)="onRegionDeleteConfirmed()" class="btn btn-warning">
                <i class="fa fa-trash"></i>{{ 'common.delete' | translate }}
            </button>
            <button
                (click)="
                    modalService.setModalVisibility(false, 'delete-region-confirmation')
                "
                class="btn btn-danger"
            >
                <i class="fa fa-remove"></i>{{ 'common.cancel' | translate }}
            </button>
        </div>
    </div>
</lib-modal>

<lib-modal
    componentID="delivery-plan-preview"
    size="xl"
    [title]="'supplier-regions.routes-replan-draft-title' | translate">
    
    <div style="max-height:600px; overflow:auto;" class="w-100">
        <pre>{{ draftDeliveryPlan | json }}</pre>
    </div>

    <div class="btn-toolbar justify-content-between mt-3">

        <button
            class="btn btn-secondary"
            (click)="modalService.setModalVisibility(false,'delivery-plan-preview')">

            {{ 'common.close' | translate }}
        </button>

        <button
            class="btn btn-success"
            (click)="onPublishDeliveryPlan()">

            {{ 'common.publish-button' | translate }}
        </button>

    </div>

</lib-modal>
